
import ProductLineCore from '../../components/product-line/product-line-core';

export default {
	name: 'product-line-addons',
	extends: ProductLineCore
};
